import BarnsheetsDailyCheckup from './BarnsheetsDailyCheckup';

export default BarnsheetsDailyCheckup;
